{
  "zh-TW": {
    "error-app.title": "發生錯誤。",
    "error-app.sub-title": "我們正在努力解決問題。",
    "error-app.detail": "請檢視我們的{link}並訂閱服務更新。",
    "error-app.link-name": "狀態頁面"
  },
  "zh-CN": {
    "error-app.title": "出错了。",
    "error-app.sub-title": "我们正竭尽全力来解决此问题。",
    "error-app.detail": "查看我们的 \"{link}\"，并订阅服务更新。",
    "error-app.link-name": "状态页面"
  },
  "tr-TR": {
    "error-app.title": "Bir hata oluştu.",
    "error-app.sub-title": "Düzeltmek için elimizden geleni yapıyoruz.",
    "error-app.detail": "{link} görüntüleyin ve hizmet güncellemelerine abone olun.",
    "error-app.link-name": "Durum sayfamızı"
  },
  "sv-SE": {
    "error-app.title": "Något gick fel.",
    "error-app.sub-title": "Vi flyttar berg för att lösa detta.",
    "error-app.detail": "Se vår {link} och prenumerera för tjänsteuppdateringar.",
    "error-app.link-name": "statussida"
  },
  "sk-SK": {},
  "ru-RU": {
    "error-app.title": "Произошла ошибка.",
    "error-app.sub-title": "Мы прилагаем все усилия, чтобы разобраться с этим.",
    "error-app.detail": "Просмотрите {link} и подпишитесь на обновления служб.",
    "error-app.link-name": "страницу статуса"
  },
  "ro-RO": {},
  "pt-PT": {},
  "pt-BR": {
    "error-app.title": "Algo deu errado.",
    "error-app.sub-title": "A gente está fazendo de tudo para resolver o problema.",
    "error-app.detail": "Visualize o {link} e se inscreva para atualizações do serviço.",
    "error-app.link-name": "página de status"
  },
  "pl-PL": {
    "error-app.title": "Coś poszło nie tak.",
    "error-app.sub-title": "Pracujemy ciężko nad rozwiązaniem tego problemu.",
    "error-app.detail": "Wyświetl naszą {link} i zasubskrybuj aktualizacje dotyczące usług.",
    "error-app.link-name": "stronę statusu"
  },
  "no-NO": {
    "error-app.title": "Det oppstod en feil.",
    "error-app.sub-title": "Vi gjør alt vi kan for å få ordnet det.",
    "error-app.detail": "Se {link} og abonner for tjenesteoppdateringer.",
    "error-app.link-name": "statusside"
  },
  "nl-NL": {
    "error-app.title": "Er is iets misgegaan.",
    "error-app.sub-title": "We doen er alles aan om dit te regelen.",
    "error-app.detail": "Bekijk onze {link} en abonneer voor service-updates.",
    "error-app.link-name": "statuspagina"
  },
  "ko-KR": {
    "error-app.title": "문제가 발생했습니다.",
    "error-app.sub-title": "이 문제를 해결하기 위해 모든 노력을 기울이고 있습니다.",
    "error-app.detail": "{link}을(를) 확인하고 서비스 업데이트를 구독하세요.",
    "error-app.link-name": "상태 페이지"
  },
  "ja-JP": {
    "error-app.title": "エラーが発生しました。",
    "error-app.sub-title": "現在、問題の解決に努めております。",
    "error-app.detail": "アトラシアンの{link}を確認し、サービス更新についての配信登録をしてください。",
    "error-app.link-name": "ステータス ページ"
  },
  "it-IT": {
    "error-app.title": "Si è verificato un problema.",
    "error-app.sub-title": "Stiamo spostando le montagne per risolvere il problema.",
    "error-app.detail": "Consulta il nostro {link} e iscriviti agli aggiornamenti del servizio.",
    "error-app.link-name": "pagina di stato"
  },
  "is-IS": {},
  "hu-HU": {
    "error-app.title": "Hiba történt.",
    "error-app.sub-title": "Hegyeket mozgatunk meg a megoldás érdekében.",
    "error-app.detail": "Az {link} megtekinthető, és feliratkozhatsz a szolgáltatással kapcsolatos hírekre.",
    "error-app.link-name": "állapotoldal"
  },
  "fr-FR": {
    "error-app.title": "Une erreur s'est produite.",
    "error-app.sub-title": "Nous déplaçons des montagnes pour régler le problème.",
    "error-app.detail": "Consultez notre {link} et abonnez-vous aux mises à jour du service.",
    "error-app.link-name": "Page d'état"
  },
  "fi-FI": {
    "error-app.title": "Jotakin meni vikaan.",
    "error-app.sub-title": "Yritämme kaikin voimin ratkaista ongelmaa.",
    "error-app.detail": "Katso {link} ja tilaa palvelupäivitykset.",
    "error-app.link-name": "tilasivu"
  },
  "et-EE": {},
  "es-ES": {
    "error-app.title": "Algo ha ido mal.",
    "error-app.sub-title": "Estamos haciendo todo lo posible para solucionarlo.",
    "error-app.detail": "Consulta nuestro {link} y suscríbete para obtener actualizaciones de servicio.",
    "error-app.link-name": "página de estado"
  },
  "en-ZZ": {
    "error-app.title": "⁣⁢Something went wrong.⁯⁯⁬‍⁫⁮‍⁠؜‍؜⁬⁮⁪‍‍⁫⁫⁭‍⁠⁡⁬⁫⁯⁣⁤",
    "error-app.sub-title": "⁣⁢We’re moving mountains to get it sorted.⁪⁬⁭⁬⁯⁪؜⁠⁯‍‌⁪⁮‌⁡⁠⁫‌⁬⁯‍⁭⁬⁣⁤",
    "error-app.detail": "⁣⁢View our {link} and subscribe for service updates.⁪⁭‍؜⁪⁡⁫‍⁭؜⁮⁮⁬؜‍‌⁪⁪⁪⁬‍⁮⁣⁤",
    "error-app.link-name": "⁣⁢status page⁭؜⁠⁯⁡⁪‌⁯⁡‍⁬⁮⁮⁮⁫⁭⁭⁫⁪⁫‌⁠‌⁮⁣⁤"
  },
  "en-US": {
    "error-app.title": "Something went wrong.",
    "error-app.sub-title": "We’re moving mountains to get it sorted.",
    "error-app.detail": "View our {link} and subscribe for service updates.",
    "error-app.link-name": "status page"
  },
  "en-GB": {
    "error-app.title": "Something went wrong.",
    "error-app.sub-title": "We’re moving mountains to get it sorted.",
    "error-app.detail": "View our {link} and subscribe for service updates.",
    "error-app.link-name": "status page"
  },
  "de-DE": {
    "error-app.title": "Ein Fehler ist aufgetreten.",
    "error-app.sub-title": "Wir arbeiten mit Hochdruck daran, dies in Ordnung zu bringen.",
    "error-app.detail": "Sehen Sie sich diesen Link {link} an und abonnieren Sie Service-Updates.",
    "error-app.link-name": "Statusseite"
  },
  "da-DK": {
    "error-app.title": "Noget gik galt.",
    "error-app.sub-title": "Vi flytter bjerge for at få det ordnet.",
    "error-app.detail": "Se vores {link}, og abonner på serviceopdateringer.",
    "error-app.link-name": "statusside"
  },
  "cs-CZ": {
    "error-app.title": "Něco se pokazilo.",
    "error-app.sub-title": "Děláme všechno pro to, abychom problém vyřešili.",
    "error-app.detail": "Podívejte se na naši {link} a přihlaste se k odběru aktualizací ohledně služeb.",
    "error-app.link-name": "stavovou stránku"
  }
}